import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { createPacker, editPacker, resetCreatePacker, resetEditPacker } from '../../actions/settings_actions';
import PackerForm from '../../components/General/packerForm';

function mapStateToProps(state) {
  return {
    currentPacker: state.settings.currentPacker,
    initialValues: state.settings.currentPacker,
    isCreating: state.settings.isCreating,
    createError: state.settings.createError,
    created: state.settings.created,
    isEditing: state.settings.isEditing,
    editError: state.settings.editError,
    edited: state.settings.edited,
  };
}

const packerForm = reduxForm({
  form: 'packerForm',
  // validate,
})(PackerForm);

export default connect(mapStateToProps, {
  createPacker, editPacker, resetCreatePacker, resetEditPacker,
})(packerForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/General/packerForm.jsx